<script setup>
import useActionButtonsCommon from "@/composables/ActionButtonsCommon";

const { store, loading, _error, selectedDevices, selectedDevicesGrouped } =
  useActionButtonsCommon();

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const closeModal = () => {
  _error.value = null;
  emit("update:modelValue", false);
};

const archiveDevices = async () => {
  const payload = {
    ids: selectedDevices.value.map((s) => s.id),
    imeis: selectedDevices.value.map((s) => s.imei),
    courses: selectedDevices.value.map((s) => s.server_name),
  };
  try {
    loading.value = true;
    const response = await store.dispatch("devices/archiveDevices", payload);
    store.dispatch("toastNotification/displayToast", {
      message:
        response.msg ||
        `Device${
          selectedDevices.value.length > 1 ? "s" : ""
        } archived successfully`,
      type: "success",
    });
    closeModal();
  } catch (error) {
    loading.value = false;
    _error.value =
      error.message ||
      `Failed to archive device${selectedDevices.value.length > 1 ? "s" : ""}`;
  }
};
</script>

<template>
  <div v-if="modelValue">
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-backdrop fade show" @click="closeModal"></div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Archive Device{{ selectedDevices.length > 1 ? "s" : "" }}
            </h4>
            <button type="button" class="close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div
              v-for="[key, course] in Object.entries(selectedDevicesGrouped)"
              :key="key"
            >
              <p class="font-weight-bold">{{ key }}</p>

              <ul class="list-unstyled mb-0 pl-3">
                <li v-for="device in course" :key="device.id">
                  • {{ device.imei }}
                </li>
              </ul>
            </div>
            <p v-if="_error" class="text-danger">{{ _error }}</p>
          </div>

          <div class="modal-footer justify-content-end">
            <button type="button" class="btn btn-danger" @click="closeModal">
              CLOSE
            </button>
            <button
              v-if="!loading"
              type="button"
              class="btn btn-success"
              @click="archiveDevices"
              :disabled="!selectedDevices.length"
            >
              ARCHIVE DEVICE{{ selectedDevices.length > 1 ? "S" : "" }}
            </button>
            <div
              v-if="loading"
              class="justify-content-center align-items-center"
              style="text-align: center"
            >
              <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "@/styles/modal.css";

.list-unstyled li {
  margin-bottom: 0.5rem;
}
</style>
